import { useLocation, Path } from 'components/_hooks/use-router';
import { useSbCb } from 'components/app/storyboard/_mediator/use-sb-cb';
import { useFinalcutCb } from 'components/app/finalcuts/_mediator/use-finalcut-cb';
import { useMemo } from 'react';

export const useWsSeek = () => {
  const { path } = useLocation();
  const { sbSeekTo } = useSbCb();
  const { fcSeekTo } = useFinalcutCb();
  return useMemo(() => {
    if (path === Path.storyboard) return (value: Fraction) => sbSeekTo(value, 'fraction');
    return fcSeekTo;
  }, [path]);
};
